const aestheticOptions = [
  {
    label: "Flat",
    value: "flat",
  },
  {
    label: "Gradient",
    value: "gradient",
  },
];

const borderRadiusOptions = [
  {
    label: "None",
    value: 0,
  },
  {
    label: "Light",
    value: 5,
  },
  {
    label: "Round",
    value: 15,
  },
  {
    label: "Pill",
    value: 100,
  },
];

const boxShadowOptions = [
  {
    label: "None",
    value: "none",
  },
  {
    label: "Small",
    value: "1px 1px 3px rgba(0, 0, 0, 0.8)",
  },
  {
    label: "Medium",
    value: "3px 3px 5px rgba(0, 0, 0, 0.9)",
  },
  {
    label: "Large",
    value: "3px 3px 10px rgba(0, 0, 0, 1)",
  },
];

const fontFamilyOptions = [
  {
    label: "Jost",
    value: "Jost",
  },
  {
    label: "Montserrat",
    value: "Montserrat",
  },
  {
    label: "Raleway",
    value: "Raleway",
  },
  {
    label: "Oswald",
    value: "Oswald",
  },
  {
    label: "Outfit",
    value: "Outfit",
  },
];

const findOptionByValue = (options, value) => {
  return options.find((option) => option.value === value);
};

export {
  aestheticOptions,
  borderRadiusOptions,
  boxShadowOptions,
  fontFamilyOptions,
  findOptionByValue,
};
